import { useMutation } from '@tanstack/react-query';

import { downloadBlob } from '../fetch';

type Payload = {
  ids: number[];
};

export const useDownloadInvoiceFcFiles = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return downloadBlob('/invoices/download/fc-files', {
        method: 'POST',
        body,
      });
    },
  });
};
